var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page "},[_c('pre',{staticClass:"main"},[_vm._v("    "+_vm._s(_vm.intro)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }